import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import React, { Component } from 'react';
import * as enums from '../../../../utils/EnumMapping';
import { DateCell } from '../../../../utils/Cells'

class Vacations extends Component {
    componentDidMount() {
        console.log(this.props);
    }
    render() {
        return (
            <TableContainer component={Paper}>
                <Table size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Típus</TableCell>
                            <TableCell>Kezdő dátum</TableCell>
                            <TableCell>Vég dátum</TableCell>
                            <TableCell>Napok száma</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.props.row.vacations.map(vac => {
                            return <TableRow key={vac.privateId}>
                                <TableCell>{enums.getLabel(enums.vacationTypes, vac.type)}</TableCell>
                                <TableCell><DateCell value={vac.startDate} /></TableCell>
                                <TableCell><DateCell value={vac.endDate} /></TableCell>
                                <TableCell>{vac.days}</TableCell>
                            </TableRow>
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }
}
export default Vacations;